export default function About() {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-950 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <span className="text-yellow-400 font-bold">代表メッセージ</span>
            </div>

            <h3 className="text-3xl font-bold mb-6 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              中小企業の補助金活用・法務リスク削減・集客力向上を<br />
              <span className="text-yellow-400">"一社で完結"</span>させる仕組みを作りたい
            </h3>

            <div className="space-y-4 text-blue-100 leading-relaxed">
              <p>
                多くの中小企業が、補助金の情報収集に時間を取られ、法務リスクに不安を抱え、集客の方法に悩んでいます。
              </p>
              <p>
                これらの課題は本来、密接に関連しているにもかかわらず、それぞれ別の専門家に依頼しなければならず、連携が取れないまま進行してしまうことが多いのが現状です。
              </p>
              <p>
                <strong className="text-white">「補助金を活用して設備を導入したのに、それを集客に活かせていない」</strong><br />
                <strong className="text-white">「契約書のリスクを相談したいが、補助金の専門家は法務が分からない」</strong>
              </p>
              <p>
                こうした"バラバラ問題"を解決するために、TOKAN補助金コンサルタントは誕生しました。
              </p>
              <p className="text-lg font-bold text-yellow-400">
                補助金 × 法務 × LP制作を一気通貫で提供することで、中小企業の成長を加速させる。それが私たちの使命です。
              </p>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
                <i className="ri-user-line text-4xl text-yellow-400"></i>
              </div>
              <div>
                <div className="text-sm text-blue-300 mb-1">TOKAN補助金コンサルタント</div>
                <div className="text-xl font-bold">代表 行政書士</div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
              <h4 className="text-2xl font-bold mb-6 flex items-center gap-3">
                <i className="ri-building-line text-yellow-400"></i>
                事務所概要
              </h4>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-2-line text-yellow-400"></i>
                  </div>
                  <div>
                    <div className="text-sm text-blue-300 mb-1">事務所名</div>
                    <div className="font-bold">TOKAN補助金コンサルタント</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-yellow-400"></i>
                  </div>
                  <div>
                    <div className="text-sm text-blue-300 mb-1">所在地</div>
                    <div className="font-bold">神奈川県横浜市</div>
                    <div className="text-sm text-blue-200 mt-1">（詳細はお問い合わせ時にご案内）</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-yellow-400"></i>
                  </div>
                  <div>
                    <div className="text-sm text-blue-300 mb-1">資格</div>
                    <div className="font-bold">行政書士</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-2-line text-yellow-400"></i>
                  </div>
                  <div>
                    <div className="text-sm text-blue-300 mb-1">対応エリア</div>
                    <div className="font-bold">神奈川県・東京都（オンライン対応で全国可）</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-service-line text-yellow-400"></i>
                  </div>
                  <div>
                    <div className="text-sm text-blue-300 mb-1">主なサービス</div>
                    <div className="font-bold">補助金申請支援 / 法務サポート / LP制作</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
